import type { CampaignScopedSubLocation, SubLocation } from "@/lib/wartungen";

/**
 * Welche Unterorte die Wartung einschränkt.
 *
 * Eine feste Auswahl (`maintenance_campaign_sub_location`) bleibt verbindlich.
 * Stockwerke, auf denen schon Objekte liegen, kommen dazu — auch ohne eigenen
 * Eintrag (z. B. 6.OG/7.OG nur über den Plan).
 *
 * Ohne feste Auswahl gilt der ganze Standort. Objekt-Stockwerke dürfen die
 * Liste dann nicht auf belegte Stockwerke verengen, sonst verschwinden neu
 * angelegte, noch leere Stockwerke, sobald woanders gewartet wird.
 */
export function campaignScopedSubLocationIds(
  scopedFromCampaign: CampaignScopedSubLocation[],
  assets: Array<{ sub_location_id?: number | null }>,
): number[] {
  const fromCampaign = scopedFromCampaign
    .map((row) => Number(row.sub_location_id))
    .filter((id) => Number.isFinite(id) && id > 0);
  if (!fromCampaign.length) return [];

  const fromAssets = assets
    .map((asset) => Number(asset.sub_location_id))
    .filter((id) => Number.isFinite(id) && id > 0);
  return [...new Set([...fromCampaign, ...fromAssets])];
}

export function filterSubLocationsForScope(all: SubLocation[], scopedIds: number[]): SubLocation[] {
  if (!scopedIds.length) return all;
  const includeIds = new Set(scopedIds);
  const byId = new Map<number, SubLocation>();
  for (const entry of all) {
    const id = Number(entry.id);
    if (Number.isFinite(id) && id > 0) byId.set(id, entry);
  }
  for (const id of scopedIds) {
    let current = byId.get(id);
    while (current) {
      const parentId = Number((current as { parent_id?: number }).parent_id);
      if (!Number.isFinite(parentId) || parentId <= 0 || includeIds.has(parentId)) break;
      includeIds.add(parentId);
      current = byId.get(parentId);
    }
  }
  return all.filter((entry) => {
    const id = Number(entry.id);
    return Number.isFinite(id) && id > 0 && includeIds.has(id);
  });
}
